class IUserRole {
    public concurrencyStamp: string = '';
    public id: string = '';
    public name: string = '';
    public normalizedName: string = '';
}

class IUser {
    public id: string = '';
    public email: string = '';
    public firstName: string = '';
    public lastName: string = '';
    public location: string = '';
    public phoneAlternate: string = '';
    public phoneMobile: string = '';
    public phoneNumber: string = '';
    public roles?: any[] = [];
    public password: string = '';
    public newPassword: string = '';
    public confirmPassword: string = '';
    public status: string = 'Active';
    public notificationEmail: string = '';
    public preferences: object = {};
}

export {
    IUser,
    IUserRole,
};


// WEBPACK FOOTER //
// ./src/Interfaces/UserInterface.tsx